// @flow
import React from "react";
import {CircleAlert, CircleCheck, Info} from "lucide-react";
import Icon from "../icons/Icon";
import "./InlineNotice.scss";

export type NoticeKind = "success" | "error" | "info";

// a notice kept in a component's state: its kind and the translation key of its text
export type Notice = {kind: NoticeKind, text: string};

const ICONS = {success: CircleCheck, error: CircleAlert, info: Info};

type InlineNoticeProps = {
    kind?: NoticeKind,
    id?: string,
    children: any,
};

/**
 * Feedback where it belongs - under the coupon field, above the send button, in the cart - in place
 * of a toast in a corner of the page (#57041). An error is announced at once, the rest politely.
 */
const InlineNotice = ({kind = "info", id, children}: InlineNoticeProps) =>
    <div id={id} className={`hpm-inlineNotice hpm-inlineNotice--${kind}`} role={kind === "error" ? "alert" : "status"}>
        <Icon icon={ICONS[kind]} size={18}/>
        <span className="hpm-inlineNotice-text">{children}</span>
    </div>;

export default InlineNotice;
